module.exports = __webpack_public_path__ + "static/about-1-1-4ce12ce778410d0be28d5243797aa856.jpg";